export class ActivityFilterOption {
    readonly value: string;
    readonly description: string;
    readonly getStartTimestamp: () => number;

    constructor(
        value: string,
        description: string,
        getStartTimestamp: () => number
    ) {
        this.value = value;
        this.description = description;
        this.getStartTimestamp = getStartTimestamp;
    }

    public static Month = new ActivityFilterOption(
        "30-days",
        "last 30 days",
        () => {
            const start = new Date();
            start.setDate(start.getDate() - 30);
            return start.getTime();
        }
    );
    public static Quarter = new ActivityFilterOption(
        "90-days",
        "last 90 days",
        () => {
            const start = new Date();
            start.setDate(start.getDate() - 90);
            return start.getTime();
        }
    );
    public static Year = new ActivityFilterOption(
        "12-months",
        "last 12 months",
        () => {
            const start = new Date();
            start.setMonth(start.getMonth() - 12);
            return start.getTime();
        }
    );
    public static All = new ActivityFilterOption(
        "all",
        "all",
        () => 1420063200000
    );

    public static asArray = [
        ActivityFilterOption.Month,
        ActivityFilterOption.Quarter,
        ActivityFilterOption.Year,
        ActivityFilterOption.All,
    ];
}
